var MDB = window.MDB || {};;
MDB.Zeiss = MDB.Zeiss || {};
MDB.Zeiss.CampaignManagement = {};

MDB.Zeiss.CampaignManagement.Index = {
    Onload: function (config) {
        $('#campaigns-table').dataTable();
    }
};

MDB.Zeiss.CampaignManagement.Edit = 
{    Onload: function (config) {
    var startDate = $('#startDate');
    var endDate = $('#endDate');

    startDate.kendoDatePicker({
        dateInput: true,
        format: 'dd-MM-yyyy',
        parseFormats: ["dd MM yyyy"]
    });

    endDate.kendoDatePicker({
        dateInput: true,
        format: 'dd-MM-yyyy',
        parseFormats: ["dd MM yyyy"]
    });
}
};

MDB.Zeiss.CampaignManagement.Campaign = 
{    Onload: function (config) {
    $('#rows-table').dataTable();
}
};